<div class="logo-upload" (click)="openFileChooserModal()">
  <div class="image-wrapper" [ngClass]="!canEdit ? 'no-edit' : '' ">
    <ng-container *ngIf="!imageLink">
      <i class="material-symbols-outlined material-image-icon">image</i>
      <div class="middle" *ngIf="canEdit">
        <i class="material-symbols-outlined edit-icon">edit</i>
      </div>
    </ng-container>
    <ng-container *ngIf="imageLink">
      <img class="profile-image" [src]="imageLink" [ngClass]="{ rounded: roundCropper }" />
      <div class="middle" *ngIf="canEdit">
        <i class="material-symbols-outlined edit-icon">edit</i>
      </div>
    </ng-container>
  </div>
</div>
